const doc = [({"da":({"js":({"admin":({"invoices":({"expandable_content":({"create_invoice_line":"Opret fakturalinje"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;